<mat-form-field class="vin-field" appearance="outline" subscriptSizing="dynamic">
  <mat-label>VIN(s) – full {{fullVINLength}} character VIN or last {{partialVINLength}} characters</mat-label>
  <mat-chip-grid #grid aria-label="VINs to look up">
    @for (entry of entries(); track entry.value) {
      <mat-chip-row (removed)="remove(entry)">
        <span class="vin-value">{{ entry.value }}</span>
        <span class="vin-kind"
              [class.vin-kind--full]="entry.kind === 'full'"
              [class.vin-kind--partial]="entry.kind === 'partial'"
              [class.vin-kind--invalid]="!entry.kind">{{ kindLabel(entry) }}</span>
        <button matChipRemove [attr.aria-label]="'Remove ' + entry.value">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
    <input
      placeholder="Type or paste more VINs…"
      [matChipInputFor]="grid"
      [matChipInputSeparatorKeyCodes]="separatorKeys"
      [matChipInputAddOnBlur]="true"
      [disabled]="entries().length >= max"
      (matChipInputTokenEnd)="add($event)"
      (paste)="onPaste($event)" />
  </mat-chip-grid>
  <mat-hint>Separate with commas · up to {{ max }} VINs · either the full {{fullVINLength}} character VIN or the last {{partialVINLength}} characters</mat-hint>
</mat-form-field>

<div class="vin-counts">
  <strong>{{ counts().total }} {{ counts().total === 1 ? 'VIN' : 'VINs' }} entered</strong>
  <span>· {{ counts().full }} full</span>
  <span>· {{ counts().partial }} partial</span>
  @if (counts().invalid) {
    <span class="vin-counts--error">· {{ counts().invalid }} invalid — remove to search</span>
  }
  @if (dropped()) {
    <span class="vin-counts--error">· {{ dropped() }} not added ({{ max }} max)</span>
  }
</div>
